module.exports = __webpack_public_path__ + "img/colorBox4.43d291fa.jpg";